import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { EDevice, URL_ROUTES } from '@/constants';
import phoneAndCencopayLogo from '@/modules/perseo-billing/assets/images/phone-and-cencopay-logo.png';
import { ModalWrapper } from '@/modules/perseo-billing/components';
import { ECencopayModalOriginCancelType } from '@/modules/perseo-billing/containers/payment-methods/components/cencopay';
import {
  BtnPrimary,
  BtnPrimaryOutlined
} from '@/modules/perseo-billing/containers/payment-methods/components/cencopay/components/btns-atoms';
import { detectDevice } from '@/modules/perseo-billing/hooks';
import { EPayStatus } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import {
  setCancelOrderChangePaymentMethod,
  setIsGenericModalVisible,
  setIsModalCencopayGetTheAppVisible,
  setIsModalQRCencopayVisible
} from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

export const CencopayGetTheAppModal = () => {
  const { cencoPayStatus } = useAppSelector((state) => state.billing);

  const dispatch = useAppDispatch();

  const { isModalCencopayGetTheAppVisible } =
    useAppSelector((state) => state?.billing) || {};

  const handlerOpenModal = () => {
    dispatch(setIsModalCencopayGetTheAppVisible(true));
  };

  const handlerCloseModal = () => {
    dispatch(
      setIsGenericModalVisible({
        title: 'isModalCencopayGetTheAppVisible',
        value: false
      })
    );
    dispatch(
      setCancelOrderChangePaymentMethod(
        ECencopayModalOriginCancelType.CHANGE_OF_APP_MODAL
      )
    );
  };

  const handleGetTheApp = () => {
    const device = detectDevice();

    if (device === EDevice.IOS) {
      redirectToUrl(URL_ROUTES.DOWNLOAD_CENCOPAY_IOS);
    }

    if (device === EDevice.ANDROID) {
      redirectToUrl(URL_ROUTES.DOWNLOAD_CENCOPAY_ANDROID);
    }

    return dispatch(setIsModalCencopayGetTheAppVisible(false));
  };

  useEffect(() => {
    const closeModalIfNeeded = () => {
      if (
        cencoPayStatus &&
        cencoPayStatus !== EPayStatus.PENDING &&
        isModalCencopayGetTheAppVisible
      ) {
        dispatch(setIsModalCencopayGetTheAppVisible(false));
        dispatch(setIsModalQRCencopayVisible(true));
      }
    };

    closeModalIfNeeded();

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        closeModalIfNeeded();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isModalCencopayGetTheAppVisible, cencoPayStatus, dispatch]);

  const modalContent = (
    <ModalWrapper
      size="sm"
      open={isModalCencopayGetTheAppVisible}
      onClose={handlerOpenModal}
      roundedType="FIXED_BOTTOM"
    >
      <Card p={16}>
        <div className="co-flex co-flex-col co-gap-[32px] co-px-[8px] co-pt-4 co-pb-[8px]">
          <div className="co-flex co-justify-center">
            <img
              src={phoneAndCencopayLogo}
              alt={'product'}
              width={208}
              height={156}
              className="co-mr-[40px]"
            />
          </div>
          <div className="co-flex co-flex-col co-gap-y-[16px]">
            <Typography
              className="co-font-[22px] co-justify-center"
              size="h3"
              weight="semibold"
            >
              Aún no tienes la app
            </Typography>
            <Typography className="co-font-[16px] co-text-center">
              Debes tener la app en tu celular para pagar con CencoPay
            </Typography>
          </div>
          <div className="co-flex co-flex-col co-gap-y-[16px]">
            <BtnPrimary label={'Descargar app'} actionClick={handleGetTheApp} />
            <BtnPrimaryOutlined
              label={'Usar otro medio de pago'}
              actionClick={handlerCloseModal}
            />
          </div>
        </div>
      </Card>
    </ModalWrapper>
  );

  const modalRoot = document.getElementById('modal-cencopay-get-the-app');
  return modalRoot && createPortal(modalContent, modalRoot);
};
